import { FormlyFieldConfig } from "@ngx-formly/core";

export class ConcreteMixtureForm {
    fields: FormlyFieldConfig[];

    actionText = 'button.save';

    constructor(translateService) {

      this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
                required: true,
                placeholder: translateService.instant('concretes.mixtures.name.placeholder')
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'concreteType',
              type: 'input', // Assuming text input for now, could be select if options are known
              wrappers: ['default-wrapper'],
              props: {
                required: true,
                placeholder: translateService.instant('concretes.mixtures.concreteType.placeholder')
              },
              expressions: {
                'props.label': translateService.stream('fields.concreteType')
              }
          },
          {
              key: 'plant',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
                required: false,
                placeholder: translateService.instant('fields.plant')
              },
              expressions: {
                'props.label': translateService.stream('fields.plant')
              }
          },
          {
              key: 'fck',
              type: 'input-number',
              wrappers: ['default-wrapper'],
              props: {
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.fck')
              }
          },
          {
              key: 'isCertified',
              type: 'checkbox',
              wrappers: ['checkbox-wrapper'],
              defaultValue: false,
              props: {
              },
              expressions: {
                'props.label': translateService.stream('fields.isCertified')
              }
          },
          {
              key: 'certificationLevel',
              type: 'select',
              wrappers: ['default-wrapper'],
              hideExpression: '!model.isCertified',
              props: {
                required: true,
                options: [
                  { value: 'FULLY_CERTIFIED', label: translateService.instant('qualityControl.certification.fullyCertified') },
                  { value: 'PARTIALLY_CERTIFIED', label: translateService.instant('qualityControl.certification.partiallyCertified') }
                ]
              },
              expressions: {
                'props.label': translateService.stream('fields.certificationLevel')
              }
          },
          {
              key: 'certificationDispersionValue',
              type: 'input-number',
              wrappers: ['default-wrapper'],
              hideExpression: '!model.isCertified || model.certificationLevel !== "PARTIALLY_CERTIFIED"',
              props: {
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.certificationDispersionValue')
              }
          },
          {
              key: 'theoreticalCementContent',
              type: 'input-number',
              wrappers: ['default-wrapper'],
              props: {
                required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.theoreticalCementContent')
              }
          },
          {
              key: 'theoreticalWaterCementRatio',
              type: 'input-number',
              wrappers: ['default-wrapper'],
              props: {
                required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.theoreticalWaterCementRatio')
              }
          }
      ];
    }    
}
